var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isCookeBarVisible()
    ? _c("div", { staticClass: "cookie-bar-cont" }, [
        _c(
          "div",
          { staticClass: "cookie-bar", on: { click: _vm.hideCookieBar } },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "svg-cont", on: { click: _vm.hideCookieBar } },
              [_c("svg-icon", { attrs: { "icon-name": "icon-cross" } })],
              1
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", [
        _vm._v(
          "Futurum.cc uses cookies (and similar techniques) to make our site more personal for you, for analysis and to provide you with relevant messages on our site or third party sites. By continuing to use our site you agree to this."
        ),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.futurum.cc/html/cookie_statement.html",
            onclick:
              "window.open('https://www.futurum.cc/html/cookie_statement.html', '', 'width=800, height=600, scrollbars=yes, resizable=yes');return false",
          },
        },
        [_vm._v("Read more")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }